var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file toast组件
 * @author (zhangwenting)
 */

/* global getComputedStyle window */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { noop, classPrefix } from '../../common/util';

import './Toast.less';

/**
 *  参数说明
 *
 *  info                  必需，  设置toast提示信息内容，任意字符串
 *  type                  非必需，设置toast的类型，可选值【info | warning | success | error】，默认值 info
 *  delay                 非必需，设置toast显示时间，number 默认值 3500
 *  isStress              非必需，设置toast是否为强调模式，true|false，默认值 false
 *  level                 非必需，设置toast的z-index值，number，默认值 999
 *
 */

var Toast = function (_Component) {
    _inherits(Toast, _Component);

    function Toast(props) {
        _classCallCheck(this, Toast);

        var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));

        _this.setHeight = function () {
            var style = getComputedStyle(_this.transBoxInner);
            var outterHeight = parseInt(style.height, 10) + 10;
            setTimeout(function () {
                _this.transBox.style.height = outterHeight + 'px';
            }, 0);
        };

        _this.onCancel = _this.onCancel.bind(_this);
        _this.timeoutId = null;
        return _this;
    }

    _createClass(Toast, [{
        key: 'onCancel',
        value: function onCancel() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            this.props.onCancel();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (!this.props.isStress) {
                this.timeoutId = setTimeout(this.onCancel, this.props.delay);
            }
            var style = getComputedStyle(this.transBoxInner);
            var outterHeight = parseInt(style.height, 10) + 10;
            setTimeout(function () {
                _this2.transBox.style.height = outterHeight + 'px';
            }, 0);
            window.addEventListener('resize', this.setHeight);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            window.removeEventListener('resize', this.setHeight);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _this3 = this;

            var _props = this.props,
                type = _props.type,
                isStress = _props.isStress,
                delay = _props.delay,
                level = _props.level,
                info = _props.info,
                classPrefix = _props.classPrefix,
                responsive = _props.responsive;

            var iconClass = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-toast-icon', true), _defineProperty(_classnames, classPrefix + '-toast-icon-' + type, true), _classnames));
            var animation = '\n            translate .2s ease-out ' + (!isStress ? ', moveOut 0.6s ease-in-out ' + (delay - 500) + 'ms' : '') + '\n        ';

            var rootClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-toast-root', true), _defineProperty(_classnames2, 'responsive', responsive), _classnames2));

            return React.createElement(
                'div',
                {
                    style: { height: 0 },
                    ref: function ref(transBox) {
                        _this3.transBox = transBox;
                    }
                },
                React.createElement(
                    'div',
                    {
                        className: rootClass,
                        style: { zIndex: level, animation: animation },
                        ref: function ref(transBoxInner) {
                            _this3.transBoxInner = transBoxInner;
                        }
                    },
                    React.createElement('div', { className: iconClass }),
                    React.createElement(
                        'div',
                        { className: classPrefix + '-toast-info' },
                        info
                    ),
                    isStress ? React.createElement('div', {
                        onClick: this.onCancel,
                        className: classPrefix + '-toast-closeBtn'
                    }) : null
                )
            );
        }
    }]);

    return Toast;
}(Component);

export default Toast;


Toast.defaultProps = {
    type: 'info',
    isStress: false,
    info: '',
    delay: 3500,
    level: 999,
    onCancel: noop,
    classPrefix: classPrefix
};

Toast.propTypes = {
    type: PropTypes.string,
    isStress: PropTypes.bool,
    info: PropTypes.string.isRequired,
    delay: PropTypes.number,
    level: PropTypes.number,
    onCancel: PropTypes.func,
    classPrefix: PropTypes.string,
    responsive: PropTypes.bool
};